// extracted by mini-css-extract-plugin
module.exports = {"theResidencesIntroHeading":"style_theResidencesIntroHeading__CL56b"};